import { Component, OnInit } from '@angular/core'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CommonService } from '../../../shared/services/common.service'
import { Router } from '@angular/router'
import { BulkServiceService } from '../bulk-service.service'
import { LaunchDialogService } from '@spartacus/storefront'
import { FormControl, FormGroup, FormBuilder } from '@angular/forms'
import { take } from 'rxjs/operators'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
@Component({
  standalone: false,
  selector: 'app-bulk-order-cart-modal',
  templateUrl: './bulk-order-cart-modal.component.html',
  styleUrls: ['./bulk-order-cart-modal.component.scss'],
})
export class BulkOrderCartModalComponent implements OnInit {
  cartId
  public getBulkOrderCartCode
  public bulkModalCode
  public modalCartRes
  public cartBomId
  userType: string
  loggedIn: boolean
  public gotCartGetRes
  cartModal: FormGroup
  public gotSuccArr
  public secondObjRes
  public getFailuresCount
  public bulkModalCode1 = ''
  public cartCode
  constructor(
    public commonService: CommonService,
    private router: Router,
    private bulkService: BulkServiceService,
    protected cartService: ActiveCartFacade,
    private launchDialogService: LaunchDialogService,
    private auth: AuthService,
    private formBuilder: FormBuilder,
    private globalMessageService: GlobalMessageService
  ) {
    this.cartService.getActiveCartId().subscribe(
      (data) => {
        this.cartId = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {})
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.loggedIn = true
          this.userType = 'current'
        } else {
          this.loggedIn = false
          this.userType = 'anonymous'
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.cartModal = this.formBuilder.group({
      cartid: new FormControl(''),
    })
    // this.getFailuresCount = this.bulkService.getFailureCount();

    this.getBulkCartId()
    this.bulkService.recieveSucArr.subscribe((success) => {
      this.gotSuccArr = success
    })
    // this.gotSuccArr = this.bulkService.getSuccessArr();
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.loggedIn = true
          this.userType = 'current'
        } else {
          this.loggedIn = false
          this.userType = 'anonymous'
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  getBulkCartId() {
    const urlparams = [
      'users',
      this.userType,
      'carts',
      this.cartId,
      'autogeneratecartid',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)
    this.commonService.getData(apiUrl).subscribe(
      (success) => {
        this.modalCartRes = success

        this.bulkModalCode = this.modalCartRes.code
        this.bulkModalCode1 = this.modalCartRes.code

        //console log code heree
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  getNextBulkCode() {
    let patchObj = {
      cartname: this.cartId,
    }
    const urlparams = ['users', this.userType, 'carts', this.cartId, 'save']
    const apiUrl = this.commonService.constructUrl(urlparams)
    this.commonService
      .patchData(apiUrl, patchObj, {
        params: {
          saveCartName: this.cartId,
        },
      })
      .subscribe(
        (success) => {
          this.getBulkOrderCartCode = success
          //*********calling second post method for bom entries using first API cart ID********************

          const urlparams = [
            'users',
            this.userType,
            'carts',
            this.getBulkOrderCartCode,
          ]
          const apiUrl = this.commonService.constructUrl(urlparams)
          this.commonService.getData(apiUrl).subscribe(
            (success) => {
              this.gotCartGetRes = success

              this.cartCode = this.gotCartGetRes.code

              const urlparams = [
                'users',
                this.userType,
                'carts',
                this.cartCode,
                'bulkUploadEntries',
              ]
              const apiUrl = this.commonService.constructUrl(urlparams)

              let orderEntriesArray = []
              let orderEntryObj = {}

              for (let productItem of this.gotSuccArr) {
                //------. for looop starts
                orderEntryObj = {
                  product: {
                    code: productItem.product.partNumber,
                  },
                  quantity: productItem.quantity,
                }
                orderEntriesArray.push(orderEntryObj)
              } //---. for loop ends
              const apiParams = {
                OrderEntries: orderEntriesArray,
              }
              this.commonService.postData(apiUrl, apiParams).subscribe(
                (success) => {
                  this.secondObjRes = success

                  // if (this.getFailuresCount > 0) {
                  const componentdata = {}

                  const bulkOrderDialog = this.launchDialogService.openDialog(
                    VS_LAUNCH_CALLER.BULK_ORDER,
                    undefined,
                    undefined,
                    componentdata
                  )
                  if (bulkOrderDialog) {
                    bulkOrderDialog.pipe(take(1)).subscribe((value) => {})
                    this.launchDialogService.dialogClose.subscribe(
                      (value) => {}
                    )
                  }

                  // } else {
                  //   this.router.navigate(['bulk-Order-Confirm']);
                  // }
                },
                (error) => {}
              )
            },
            (err) => {}
          )
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      reason: reason,
      type: VS_LAUNCH_CALLER.BULK_ORDER_CART,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
